function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useCallback, useEffect, useMemo, useState } from "react";
import merge from "lodash/merge";
import { useProfileContext } from "./context";
/**
 * Use profile data exposed through an mbox similar to React.useState.
 */ function useProfile(mbox, initialState) {
    if (initialState === void 0) initialState = {};
    var _manager_cache_mboxes_mbox, _manager_cache_mboxes, _manager_cache, _manager;
    var manager = useProfileContext();
    var _useState = _sliced_to_array(useState(), 2), render = _useState[0], rerender = _useState[1];
    useEffect(function() {
        var _manager;
        return (_manager = manager) == null ? void 0 : _manager.register(mbox);
    }, [
        manager,
        mbox
    ]);
    useEffect(function() {
        var _manager;
        return (_manager = manager) == null ? void 0 : _manager.on("profiles-changed", function(updatedMboxes) {
            if (updatedMboxes.has(mbox)) {
                rerender({});
            }
        });
    }, [
        manager,
        mbox
    ]);
    var updateProfile = useCallback(function(param, value) {
        var _manager;
        return (_manager = manager) == null ? void 0 : _manager.queueUpdate(mbox, param, value);
    }, [
        manager,
        mbox
    ]);
    var state = useMemo(function() {
        var _manager;
        return merge({}, initialState, ((_manager = manager) == null ? void 0 : _manager.getProfile(mbox)) || {});
    }, // Can't use initialState in the dependency list because it defaults to a new object which would cause an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        manager,
        mbox,
        render
    ]);
    var ready = ((_manager = manager) == null ? void 0 : (_manager_cache = _manager.cache) == null ? void 0 : (_manager_cache_mboxes = _manager_cache.mboxes) == null ? void 0 : (_manager_cache_mboxes_mbox = _manager_cache_mboxes[mbox]) == null ? void 0 : _manager_cache_mboxes_mbox.status) === "ready";
    return [
        state,
        updateProfile,
        ready
    ];
}
export default useProfile;

//# sourceMappingURL=use-profile.js.map